export default __webpack_public_path__ + "static/media/logoE4B.93f738be.png";